/** Alinhado ao backend (StatusPlanoMelhoria). */
export enum StatusPlanoMelhoria {
  Novo = 0,
  AguardandoValidacaoSupervisor = 1,
  AguardandoValidacaoPecConviva = 2,
  DevolvidoAjustes = 3,
  Aprovado = 4,
}
